const FALLBACK_HERO_CONTENT = {
  heading: 'Bike insurance starting at ₹457*',
  subHeading: 'Zero commission, zero hidden charges, and hassle-free claims - trusted by 5 Cr+ Indians',
  heroImage: {
    desktopSrc: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/bike_hero_desktop_a6c959927f.webp',
    mobileSrc: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/bike_hero_mobile_c0f696b684.webp',
    alt: 'Buy bike insurance online with ACKO — instant policy and quick claims support',
  },
  features: [
    {
      title: 'Zero commission',
      description: 'No middlemen charges',
      iconSrc: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/zero_commission_icon_8c978c7e09.svg',
      iconAlt: '',
    },
    {
      title: 'Hassle-free claims',
      description: 'Fast settlement, zero stress',
      iconSrc: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/cashless_repair_icon_4722f6a2a1.svg',
      iconAlt: '',
    },
  ],
  widget: {
    heading: "Let's insure your bike",
    inputPlaceholder: 'Enter registration number',
    ctaText: 'Check prices',
    disclaimer: '',
  },
  newFlowBanner: {
    heading: 'Insure your brand new bike',
    subHeading: 'Save up to 80% on premiums with zero-commission insurance',
    ctaText: 'Save up to 80% on premiums',
    iconSrc: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/tick_icon_dark_284cd02d1a.svg',
    iconAlt: '',
  },
}

const getMediaUrl = media => {
  if (typeof media === 'string') return media
  return media?.url || media?.data?.attributes?.url || ''
}

const getMediaAlt = media => media?.alternativeText || media?.alt || media?.data?.attributes?.alternativeText || ''

const normalizeSearch = search => {
  if (!search) return ''
  return search.startsWith('?') ? search.slice(1) : search
}

export const buildNewBikeRedirectionUrl = search => {
  const queryString = normalizeSearch(search)
  return `/bike-journey/nsr?flow=new${queryString ? `&${queryString}` : ''}`
}

export const getInitialRegistrationNumberFromSearch = search => {
  if (typeof search === 'string') {
    return new URLSearchParams(normalizeSearch(search)).get('regNo') || ''
  }

  const registrationNumber = search?.regNo
  if (Array.isArray(registrationNumber)) return registrationNumber[0] || ''
  return registrationNumber || ''
}

export const getBikeContinueInsuringJourney = journeyData => {
  if (!Array.isArray(journeyData)) return null
  return journeyData.find(item => item?.vehicle_type === 'bike') || null
}

export const getHeroContentViewModel = data => {
  const cmsFeatures = Array.isArray(data?.KeyFeatures) ? data.KeyFeatures : []
  const features = FALLBACK_HERO_CONTENT.features.map((fallbackFeature, index) => {
    const feature = cmsFeatures[index]

    return {
      title: feature?.keyFeatureHighlight || fallbackFeature.title,
      description: feature?.keyFeatureServiceProvided || fallbackFeature.description,
      iconSrc: getMediaUrl(feature?.KeyFeatureIcon) || fallbackFeature.iconSrc,
      iconAlt: getMediaAlt(feature?.KeyFeatureIcon) || fallbackFeature.iconAlt,
    }
  })

  return {
    heading: data?.productWidgetMainHeading || FALLBACK_HERO_CONTENT.heading,
    subHeading: data?.ProductWidgetSubHeading || FALLBACK_HERO_CONTENT.subHeading,
    heroImage: {
      desktopSrc: getMediaUrl(data?.productWidgetHeroImageDesktop) || FALLBACK_HERO_CONTENT.heroImage.desktopSrc,
      mobileSrc: getMediaUrl(data?.productWidgetHeroImageMobile) || FALLBACK_HERO_CONTENT.heroImage.mobileSrc,
      alt: getMediaAlt(data?.productWidgetHeroImageMobile) || FALLBACK_HERO_CONTENT.heroImage.alt,
    },
    features,
    widget: {
      heading: data?.widgetHeading || FALLBACK_HERO_CONTENT.widget.heading,
      inputPlaceholder: data?.inputPlaceholder || FALLBACK_HERO_CONTENT.widget.inputPlaceholder,
      ctaText: data?.widgetCtaText || FALLBACK_HERO_CONTENT.widget.ctaText,
      disclaimer: data?.disclaimer || FALLBACK_HERO_CONTENT.widget.disclaimer,
    },
    newFlowBanner: {
      heading: data?.newFlowBanner?.heading || FALLBACK_HERO_CONTENT.newFlowBanner.heading,
      subHeading: data?.newFlowBanner?.subHeading || FALLBACK_HERO_CONTENT.newFlowBanner.subHeading,
      ctaText: data?.newFlowBanner?.ctaText || FALLBACK_HERO_CONTENT.newFlowBanner.ctaText,
      iconSrc: getMediaUrl(data?.newFlowBanner?.iconSrc) || FALLBACK_HERO_CONTENT.newFlowBanner.iconSrc,
      iconAlt:
        getMediaAlt(data?.newFlowBanner?.iconSrc) ||
        data?.newFlowBanner?.iconAlt ||
        FALLBACK_HERO_CONTENT.newFlowBanner.iconAlt,
    },
  }
}
